// Poderes especiais da procuracao, na ordem do eproc, mais os dois poderes
// proprios do escritorio. O id e gravado no banco (associacao procurador-credor e
// credenciamento), entao os ids precisam ficar estaveis.
// AGC_POWER: quando a procuracao da associacao tem este poder, o credenciamento
// nao exige nova procuracao.
export const AGC_POWER = "agc_participation";

const data = [
  { id: "poverty_declaration", name: "Assinar declaração de hipossuficiência econômica" },
  { id: "confess", name: "Confessar" },
  { id: "discharge", name: "Dar quitação" },
  { id: "withdraw", name: "Desistir" },
  { id: "commitment", name: "Firmar compromisso" },
  { id: "receive", name: "Receber" },
  { id: "summons", name: "Receber citação" },
  { id: "acknowledge_claim", name: "Reconhecer a procedência do pedido" },
  { id: "waive_right", name: "Renunciar ao direito sobre o qual se funda a ação" },
  { id: "transact", name: "Transigir" },
  { id: "case_specific", name: "Atuação específica no caso", highlight: true },
  { id: "agc_participation", name: "Participação em Assembleia de Credores", highlight: true },
];

export default [...data];
